<script>
  import AddList from "./AddList.svelte";
  import { v4 } from "uuid";
  export let block_list = [];
  import changesStore from "../../stores/Changes";
  import Validators from "../../utils/validators";
  function parseCategories(values) {
    return values.map((val) => {
      return {
        value: val.iab_category_id,
        label: `${val.iab_category_id} | ${
          val.top_tier ? val.top_tier + " | " : ""
        }${val.name}`,
        name: val.name,
        top_tier: val.top_tier,
      };
    });
  }
  const BlockListFields = [
    {
      type: "text",
      name: "adomains",
      readonlyValue: true,
      entity: "adomain_daily",
      preventDup: true,
      validations: [
        Validators.required("Ad-Domain is required"),
        Validators.idDomain("Domain is not valid"),
      ],
      label: "Ad Domain",
      placeholder: "Insert Ad Domain (ie. domain.com)",
    },
    {
      type: "combo",
      name: "iab_category",
      isSelectAll: false,
      isClearable: true,
      //v--alidations: [Validators.required("Categories are required")],
      entity: "iab_categories",
      label: "IAB Value",
      placeholder: "Select IAB Value",
      itemParsingMethod: parseCategories,
    },
    {
      type: "combo",
      name: "categories",
      isMulti: true,
      isSelectAll: false,
      isClearable: true,
      //v--alidations: [Validators.required("Categories are required")],
      entity: "categories",
      label: "Blocklist Category",
      placeholder: "Select Category",
    },
  ];

  function onAddRow(dataObj) {
    const newBlockList = { ...dataObj, id: v4() };
    changesStore.upsert("block_list", newBlockList, true);
    block_list.push(newBlockList);
    return block_list;
  }
  function onUpdateRow(i, field, data) {
    if (data) {
      // this line sets data to undefined becase there's no data.value @svi @yehiel
      // if (typeof data != "string") data = data.value;
      if (block_list[i][field] != data) {
        block_list[i][field] = data;
        changesStore.upsert("block_list", block_list[i], false);
      }
    }
  }
  function onDeleteRow(i) {
    const [deletedBlockList] = block_list.splice(i, 1);
    changesStore.delete("block_list", deletedBlockList.adomains);
    return block_list;
  }
</script>

<AddList
  name="block_list"
  fields={BlockListFields}
  bind:data={block_list}
  {onDeleteRow}
  {onUpdateRow}
  {onAddRow}
/>
